import { FoundationsEnums } from '../../enum'
import { drillThruAllowed, getAgeDisplayfromDays, getCustomColorSeriesForGroupChart, getDurationDisplayFromHours } from './chartHelperFunctions'

export const scatterPlotOptions = (
    vuChartVariationType: string,
    vuChartData: { [s: string]: any },
    vuChartSettings: { [s: string]: any },
    vuChartDetails: { [s: string]: any },
    chartOptions: { [s: string]: any },
    userTypeId:string
) => {
    switch (vuChartVariationType) {
        default:
            break
        //case "C_1M_1X_or_1Y":
        case 'C_2M_1X_or_1Y':
        case 'C_3M_1X_or_1Y':
        case 'C_4M_1X_or_1Y':
        case 'C_5M_1X_or_1Y':
        case 'C_2M_1X_and_1Y':
        case 'C_3M_1X_and_1Y':
        case 'C_4M_1X_and_1Y':
        case 'C_5M_1X_and_1Y':
        case 'C_NM_2D':
        case 'C_NM_1D':
            {
                vuChartData.dataSeries.forEach(function (
                    dataSeries: { [s: string]: any },
                    index_i: number
                ) {
                    let dataPoints: { [s: string]: any }[] = []
                    dataSeries.Scatterdata.forEach(function (dataPoint: {
                        index: any
                        value: any
                    }) {
                        dataPoints.push([dataPoint.index, dataPoint.value])
                    })

                    chartOptions.series[index_i] = {}
                    // need a logic here ... if there is only one measure..then ... hmm
                    let titleObj: { [s: string]: any } = {}
                    titleObj.margin = 5
                    if (index_i == 0) {
                        titleObj.text = vuChartData.yAxis.title
                        chartOptions.yAxis.title = titleObj
                    } else {
                        // next y axis .. so put on opposite etc..
                    }

                    chartOptions.series[index_i].name = dataSeries.name
                    chartOptions.series[index_i].measuretype = dataSeries.measuretype
                    chartOptions.series[index_i].data = dataPoints
                    chartOptions.series[index_i].cursor = drillThruAllowed(
                        index_i,
                        vuChartDetails.AllowDrillThru,
                        vuChartDetails.MeasureList,
                        userTypeId
                    )
                        ? 'pointer'
                        : 'default'

                    let title =
                        vuChartData.legendTitle != ''
                            ? vuChartData.legendTitle
                            : vuChartData.xAxis.title
                    let barColor = getCustomColorSeriesForGroupChart(title, dataSeries.name)
                    if (barColor != '') {
                        chartOptions.series[index_i].color = barColor
                    }

                    if (
                        vuChartData.dataSeries.length == 1 &&
                        vuChartSettings.ShowChartSummation == true
                    ) {
                        ///////// TODO
                        chartOptions.series.unshift({
                            dataLabels: {
                                enabled: vuChartSettings.ShowChartSummation,
                                inside: false,
                            },
                        })
                    }

                    if (
                        (vuChartDetails.XAxisList.length == 0 &&
                            vuChartDetails.YAxisList.length == 1) ||
                        (vuChartDetails.XAxisList.length == 1 &&
                            vuChartDetails.YAxisList.length == 0)
                    ) {
                        chartOptions.legend.enabled = false
                    }

                    let labelsObj: { [s: string]: any } = {}
                    labelsObj.margin = 0
                    labelsObj.zIndex = 6

                    let dataTypeStr =
                        vuChartDetails.MeasureList[index_i].MetaData.DataType.toString()
                    switch (dataTypeStr) {
                        case FoundationsEnums.HLDataType.HLDuration:
                            labelsObj.formatter = function () {
                                return getDurationDisplayFromHours(
                                    this.value
                                )
                            }
                            break
                        case FoundationsEnums.HLDataType.HLAgeDays:
                            labelsObj.formatter = function () {
                                return getAgeDisplayfromDays(this.value)
                            }
                            break
                        default:
                            break
                    }
                    chartOptions.xAxis.labels = labelsObj

                    labelsObj = {}
                    labelsObj.margin = 0
                    labelsObj.zIndex = 6

                    dataTypeStr =
                        vuChartDetails.MeasureList[index_i + 1].MetaData.DataType.toString()
                    switch (dataTypeStr) {
                        case FoundationsEnums.HLDataType.HLDuration:
                            labelsObj.formatter = function () {
                                return getDurationDisplayFromHours(
                                    this.value
                                )
                            }
                            break
                        case FoundationsEnums.HLDataType.HLAgeDays:
                            labelsObj.formatter = function () {
                                return getAgeDisplayfromDays(this.value)
                            }
                            break
                        default:
                            break
                    }
                    chartOptions.yAxis.labels = labelsObj
                    chartOptions.yAxis.alignTicks = false
                })
            }
            // Multiple measures
            break
    }
    return chartOptions
}
